<ng-container *ngIf="isMenuOpen$ | async as isMenuOpen">
  <nav class="sidebar" [class.closed]="!isMenuOpen">
    <div class="user-info" *ngIf="currentUser">
      <p class="user-name">{{ currentUser.sub }}</p>
      <p class="company-name" *ngIf="empresaNome">{{ empresaNome }}</p>
      <button (click)="logout()" class="btn-logout flex items-center">
        <i class="fa-solid fa-sign-out-alt mr-1 text-xs" aria-hidden="true"></i>
        <span class="text-xs">Sair</span>
      </button>
    </div>

    <ul class="flex flex-col">
      <!-- Grupo Venda -->
      <li>
        <a href="#" class="flex items-center py-0.5 leading-none text-xs" (click)="toggleVendaMenu($event)">
          <i class="fa-solid fa-cash-register mr-1 text-xs"></i>
          <span>Venda</span>
        </a>
        <ul *ngIf="isVendaMenuOpen" class="submenu flex flex-col space-y-0.5 ml-4">
          <li>
            <a routerLink="/venda" class="flex items-center py-0.5 leading-none text-xs">
              <i class="fa-solid fa-cash-register mr-1 text-xs"></i>
              <span>Nova Venda</span>
            </a>
          </li>
          <li>
            <a routerLink="/buscar-venda" class="flex items-center py-0.5 leading-none text-xs">
              <i class="fa-solid fa-search mr-1 text-xs"></i>
              <span>Buscar/Alterar Pedido/Orçamento</span>
            </a>
          </li>
          <li>
            <a routerLink="/venda/pendente" class="flex items-center py-0.5 leading-none text-xs">
              <i class="fa-solid fa-clock mr-1 text-xs"></i>
              <span>Pendentes</span>
            </a>
          </li>
          <li>
            <a routerLink="/venda/relatorio" class="flex items-center py-0.5 leading-none text-xs">
              <i class="fa-solid fa-file-alt mr-1 text-xs"></i>
              <span>Relatório</span>
            </a>
          </li>
          <li>
            <a routerLink="/vendas" class="flex items-center py-0.5 leading-none text-xs">
              <i class="fa-solid fa-cash-register mr-1 text-xs"></i>
              <span>Vendas</span>
            </a>
          </li>
        </ul>
      </li>

      <!-- Divisor -->
      <li>
        <hr class="my-1 border-gray-300">
      </li>

      <!-- Grupo Produtos/Caixa/Clientes/Vendedores/Marcas/Fornecedores/Usuarios -->
      <li>
        <ul class="flex flex-col space-y-0.5">
          <li>
            <a routerLink="/produtos" class="flex items-center py-0.5 leading-none text-xs">
              <i class="fa-solid fa-cart-shopping mr-1 text-xs"></i>
              <span>Produtos</span>
            </a>
          </li>
          <li>
            <a routerLink="/caixa" class="flex items-center py-0.5 leading-none text-xs">
              <i class="fa-solid fa-cash-register mr-1 text-xs"></i>
              <span>Caixa</span>
            </a>
          </li>
          <li>
            <a routerLink="/clientes" class="flex items-center py-0.5 leading-none text-xs">
              <i class="fas fa-user-tie mr-1 text-xs"></i>
              <span>Clientes</span>
            </a>
          </li>
          <li>
            <a routerLink="/vendedores" class="flex items-center py-0.5 leading-none text-xs">
              <i class="fas fa-user-tie mr-1 text-xs"></i>
              <span>Vendedores</span>
            </a>
          </li>
          <li>
            <a routerLink="/marcas" class="flex items-center py-0.5 leading-none text-xs">
              <i class="fas fa-registered mr-1 text-xs"></i>
              <span>Marcas</span>
            </a>
          </li>
          <li>
            <a routerLink="/fornecedores" class="flex items-center py-0.5 leading-none text-xs">
              <i class="fas fa-user-tag mr-1 text-xs"></i>
              <span>Fornecedores</span>
            </a>
          </li>
          <li>
            <a routerLink="/usuarios" class="flex items-center py-0.5 leading-none text-xs">
              <i class="fas fa-user-tie mr-1 text-xs"></i>
              <span>Usuarios</span>
            </a>
          </li>
        </ul>
      </li>

      <!-- Divisor -->
      <li>
        <hr class="my-1 border-gray-300">
      </li>

      <!-- Grupo Estoque -->
      <li>
        <a href="#" class="flex items-center py-0.5 leading-none text-xs" (click)="toggleEstoqueMenu($event)">
          <i class="fa-solid fa-boxes-stacked mr-1 text-xs"></i>
          <span>Estoque</span>
        </a>
        <ul *ngIf="isEstoqueMenuOpen" class="submenu flex flex-col space-y-0.5 ml-4">
          <li>
            <a routerLink="/estoque" class="flex items-center py-0.5 leading-none text-xs">
              <i class="fa-solid fa-cash-register mr-1 text-xs"></i>
              <span>Movimentar estoque</span>
            </a>
          </li>
          <li>
            <a routerLink="/historico" class="flex items-center py-0.5 leading-none text-xs">
              <i class="fa-solid fa-sticky-note mr-1 text-xs"></i>
              <span>Histórico</span>
            </a>
          </li>
        </ul>
      </li>

      <!-- Vendas por data -->
      <li>
        <a routerLink="/vendas/por-data" class="flex items-center py-0.5 leading-none text-xs">
          <i class="fas fa-user-tag mr-1 text-xs"></i>
          <span>Vendas por data</span>
        </a>
      </li>

      <!-- Divisor -->
      <li>
        <hr class="my-1 border-gray-300">
      </li>

      <!-- Empresa -->
      <li>
        <a routerLink="/empresa" class="flex items-center py-0.5 leading-none text-xs">
          <i class="fa-solid fa-building mr-1 text-xs"></i>
          <span>Empresa</span>
        </a>
      </li>

      <!-- Assinaturas (apenas master) -->
      <li *ngIf="hasMaster()">
        <a href="#" class="flex items-center py-0.5 leading-none text-xs" (click)="toggleAssinaturaMenu($event)">
          <i class="fa-solid fa-file-contract mr-1 text-xs"></i>
          <span>Assinaturas</span>
        </a>
        <ul *ngIf="isAssinaturaMenuOpen" class="submenu flex flex-col space-y-0.5 ml-4">
          <li>
            <a routerLink="/assinaturas" class="flex items-center py-0.5 leading-none text-xs">
              <i class="fa-solid fa-list mr-1 text-xs"></i>
              <span>Listar Assinaturas</span>
            </a>
          </li>
          <li>
            <a routerLink="/assinaturas/cadastrar" class="flex items-center py-0.5 leading-none text-xs">
              <i class="fa-solid fa-plus mr-1 text-xs"></i>
              <span>Nova Assinatura</span>
            </a>
          </li>
          <li>
            <a routerLink="/empresas/cadastrar" class="flex items-center py-0.5 leading-none text-xs">
              <i class="fa-solid fa-building mr-1 text-xs"></i>
              <span>Nova Empresa</span>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</ng-container>